// Queries
import { GET_ROLES_QUERY } from '../../api/queries/queries_local';

// Hooks
import { useMultiQuery } from '../../api/queries/hooks/apiHooks';
import { EXTRACT_TENANTID_FROM_URL } from '@ibinder/common-utils';

export interface LabelsUseAllRolesForAllTypes {
  genRoleMetaData?: any;
}

export const useAllRolesForAllTypes = (
  roleTypes,
  client,
  labels: LabelsUseAllRolesForAllTypes,
  fetchPolicy = 'cache-first',
  includeDisabled = false
): [any[], boolean] => {
  const queries = roleTypes.map((type) => {
    return {
      query: GET_ROLES_QUERY,
      context: {
        headers: {
          'x-ibinder-tenantid': type.id
        }
      },
      variables: {
        filterbyRoleTypeId: type.id,
        tenantId: EXTRACT_TENANTID_FROM_URL(),
        includeDisabled
      },
      fetchPolicy
    };
  });

  const theRoles = [];
  const [data, loading] = useMultiQuery(client, queries);
  // Här behöver vi mappa in ett namn baserat på rolltypsnyckel och metadataValueForThisRole på själva rollen.
  data.map((d) =>
    d.get.map((dd) => {
      const theRoleTranslationKey = roleTypes.find(
        (e) => e.id === dd.binderRoleType.id
      );
      theRoles.push({
        ...dd,
        name: !dd.tenantSpecific
          ? labels.genRoleMetaData(
              theRoleTranslationKey.metadataElementId,
              dd.metadataValueForThisRole
            )
          : dd.name,
        binderRoleType: {
          ...dd.binderRoleType,
          metadataElementId: theRoleTranslationKey.metadataElementId
        }
      });
    })
  );

  return [theRoles, loading];
};

export const setTranslatedNameOnParticipantRoles = (participant, AllRoles) => {
  return {
    ...participant,
    technicalAreas: participant.technicalAreas.map((pt) => ({
      ...pt,
      name: AllRoles.find((ar) => ar.id === pt.id)?.name ?? pt.name
    }))
  };
};
